import React from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Mail, MessageSquare, Bell } from "lucide-react";

export const NotifyPrefsCard = ({
  prefs, email, phone, endpoint, onSaved,
  title = "Lead alert notifications",
  desc = "Choose how you'd like to be notified when a new customer lead matches your service area.",
  pushDesc = "Browser & app alerts",
  testid = "notify-prefs-card",
}) => {
  const current = prefs || { email: true, sms: true, push: true };

  const toggle = async (ch) => {
    const next = { ...current, [ch]: !current[ch] };
    onSaved({ notify_prefs: next });
    try {
      const { data } = await api.put(endpoint, next);
      onSaved({ notify_prefs: data.notify_prefs || next });
      toast.success("Notification preferences updated");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
      onSaved({ notify_prefs: current });
    }
  };

  const channels = [
    { key: "email", label: "Email", Icon: Mail, desc: email || "No email on file" },
    { key: "sms", label: "SMS text", Icon: MessageSquare, desc: phone || "No phone on file" },
    { key: "push", label: "Push / in-app", Icon: Bell, desc: pushDesc },
  ];

  return (
    <div className="card-soft mb-6" data-testid={testid}>
      <h2 className="font-heading text-xl text-[#1E3F33] mb-1 flex items-center gap-2"><Bell className="w-4 h-4 text-[#CC5A3A]"/> {title}</h2>
      <p className="text-xs text-[#8A9A86] mb-4">{desc}</p>
      <div className="grid sm:grid-cols-3 gap-3">
        {channels.map(({ key, label, Icon, desc: d }) => {
          const on = current[key] !== false;
          return (
            <button
              key={key}
              type="button"
              onClick={() => toggle(key)}
              data-testid={`notify-pref-${key}`}
              aria-pressed={on}
              className={`text-left rounded-xl border p-3 transition-colors ${on ? "border-[#2D6A4F]/40 bg-[#2D6A4F]/5" : "border-[#1E3F33]/10 bg-white hover:border-[#1E3F33]/20"}`}
            >
              <div className="flex items-center justify-between">
                <span className="inline-flex items-center gap-2 text-sm font-medium text-[#1E3F33]"><Icon className="w-4 h-4 text-[#2D6A4F]"/> {label}</span>
                <span className={`w-9 h-5 rounded-full relative transition-colors ${on ? "bg-[#2D6A4F]" : "bg-[#1E3F33]/20"}`}>
                  <span className={`absolute top-0.5 w-4 h-4 rounded-full bg-white transition-all ${on ? "left-[18px]" : "left-0.5"}`} />
                </span>
              </div>
              <p className="text-[11px] text-[#8A9A86] mt-1 truncate">{d}</p>
            </button>
          );
        })}
      </div>
    </div>
  );
};
